<template>
  <div
    class="landing-header container"
    :class="{ cursorActive: $route.params.path1 == 'card-loyal' }"
  >
    <router-link
      :to="`/${$store.state.main.locale}/about-us/`"
      class="menu-item bold uppercase"
    >
      {{ $fn.tr("ჩვენ შესახებ") }}
    </router-link>

    <router-link :to="`/${$store.state.main.locale}/`" class="d-contents">
      <svg-components
        v-if="_.get($store.state.main, 'locale') == 'ge'"
        class="about-us-logo"
        name="logo"
      />
      <svg-components
        v-else-if="_.get($store.state.main, 'locale') == 'en'"
        class="about-us-logo"
        name="eng-logo"
      />
      <svg-components
        class="about-us-logo mobile-logo pointer"
        :name="`mobile_logo_${_.get($store.state.main, 'locale')}`"
      />
    </router-link>

    <div class="default-header__top__top-right flex al-center">
      <CardDropdown />
      <div class="lang flex al-center" :class="{ active: languageOpen }">
        <div class="lang-row flex-box" @click="languageOpen = !languageOpen">
          <div class="selected-lang bold uppercase">
            {{ _.get($store.state.main, "locale") === "ge" ? "Geo" : "Eng" }}
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="7.857"
            viewBox="0 0 10 7.857"
          >
            <path
              id="Icon_material-play-arrow"
              data-name="Icon material-play-arrow"
              d="M12,7.5v10l7.857-5Z"
              transform="translate(17.5 -12) rotate(90)"
              fill="#4d4d4f"
            />
          </svg>
        </div>

        <div class="change-lang-options" @click="changeLang">
          <router-link :to="''" tag="div" class="selected-lang bold uppercase">
            {{ _.get($store.state.main, "locale") === "ge" ? "Eng" : "Geo" }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgComponents from "../SvgComponents.vue";
import CardDropdown from "../CardsDropdown.vue";

export default {
  components: {
    SvgComponents,
    CardDropdown
  },
  data() {
    return {
      languageOpen: false
    };
  },

  methods: {
    changeLang() {
      this.languageOpen = false;
      const lang =
        _.get(this.$store.state.main, "locale") === "ge" ? "en" : "ge";
      setTimeout(() => {
        this.$router.push(`/${lang}`);
      }, 200);
    }
  }
};
</script>

<style lang="scss">
.landing-header {
  width: 100%;
  height: 94px;
  display: flex;
  z-index: 9999999;
  position: relative;
  align-items: center;
  justify-content: space-between;
  cursor: none;
  * {
    cursor: none !important;
  }
  @media (max-width: 1439px) {
    height: auto;
    padding-top: 21px;
    padding-bottom: 21px;
    min-height: 67px;
  }
  @media (max-width: 1023px) {
    height: 64px;
    padding-top: 0;
    padding-bottom: 0;
    min-height: auto;
  }
  @media (max-width: 767px) {
    justify-content: space-between;
    padding: 0px 15px;
  }
  .d-contents {
    display: contents;
  }
  .about-us-logo {
    cursor: pointer;
    left: 50%;
    position: absolute;
    transform: translate(-50%, 0px);
    &.mobile-logo {
      display: none;
    }
    @media (max-width: 1439px) {
      svg {
        width: 158px;
      }
    }
    @media (max-width: 767px) {
      svg {
        width: 150px;
      }
    }
    @media (max-width: 510px) {
      &:not(.mobile-logo) svg {
        height: 14px;
      }
    }
    @media (max-width: 413px) {
      display: none;
      &.mobile-logo {
        display: block;
      }
      &.mobile-logo svg {
        width: 50px;
      }
    }
  }
  .menu-item,
  .selected-lang {
    color: $black;
    cursor: pointer;
  }
  .selected-lang {
    margin-right: 3px;
  }
  .lang {
    cursor: pointer;
    flex-direction: column;
    position: relative;

    .lang-row {
      display: flex;
      align-items: center;
      svg {
        margin-left: 5px;
      }
    }

    .change-lang-options {
      opacity: 0;
      position: absolute;
      top: 20px;
      left: 2px;
      visibility: hidden;
      max-height: 0;
      transition: 0.6s ease;
    }
    svg {
      transition: 0.4s ease-in-out;
    }
    &.active {
      .change-lang-options {
        opacity: 1;
        visibility: visible;
        max-height: 100px;
      }
      svg {
        transform: rotate(180deg);
      }
    }
  }
}
.cursorActive {
  cursor: default;
  * {
    cursor: default !important;
  }
  a {
    cursor: pointer !important;
  }
}
</style>
